import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { OnCallCenterDto, OnCallCentersService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchOnCallCenterById = (
  onCallCenterId: string,
  extraOptions?: UseQueryOptions<OnCallCenterDto, unknown, OnCallCenterDto, QueryKeys[]>
) => {
  return useQuery(
    [QueryKeys.fetchOnCallCenterById],
    async () => {
      return OnCallCentersService.onCallCentersControllerGetOnCallCenter({
        onCallCenterId: onCallCenterId,
      });
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération de la permanence');
      },
      ...extraOptions,
    }
  );
};
